import { Controller } from "@hotwired/stimulus"

// ⌘K / Ctrl+K ou « / » : focus sur la recherche. ⌘↵ : envoyer le formulaire courant.
export default class extends Controller {
  static targets = ["search"]

  connect() {
    this.onKey = (event) => {
      const typing = event.target.closest("input, textarea, select, [contenteditable]")
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault()
        this.focusSearch()
      } else if (event.key === "/" && !typing) {
        event.preventDefault()
        this.focusSearch()
      }
    }
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  focusSearch() {
    if (!this.hasSearchTarget) return
    this.searchTarget.focus()
    this.searchTarget.select()
  }

  submit(event) {
    event.preventDefault()
    event.target.form?.requestSubmit()
  }
}
